<template>
  <div
    :class="$style.component"
  >
    <div ref="zoomContainerRef">
      <h1 v-if="heading">{{heading}}</h1>
      <p class="has-xl-body-size" v-if="text">{{text}}</p>
      <button @click="$emit('start')">Aloita</button>
    </div>
  </div>
</template>

<script>
import {ref} from '@vue/composition-api'

import useZoom from '@/composition/useZoom'

export default {
  props: {
    heading: {type: String, required: false},
    text: {type: String, required: false},
  },
  setup () {
    const zoomContainerRef = ref()
    useZoom(zoomContainerRef, 2)

    return {
      zoomContainerRef,
    }
  },
}
</script>

<style module lang="scss">
.component {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 5%;
  width: 90%;
  min-height: 100%;
  padding: variables.$spacing-16;
  text-align: center;

  > div {
    max-width: variables.$breakpoint-1024;
  }

  &#{&} h1 {
    margin-bottom: variables.$spacing-32;
  }

  &#{&} p {
    margin-bottom: variables.$spacing-40;
  }

  @include media.query($from: 1024) {
    &#{&} h1 {
      margin-bottom: variables.$spacing-48;
    }

    &#{&} p {
      margin-bottom: variables.$spacing-100;
    }
  }
}
</style>
